import React from 'react';
import './HeroSection.css';
import { ReactComponent as ContactSVG } from '../assets/Contact-Us-Button.svg';

function HeroSection() {

  return (
    <section className="hero-section">
      <div className="container-padding">
        <div className="hero-header">
          <img src="/images/OMO Logo - New.svg" alt="OMO Logo" className="hero-logo-img" />
          <a href="#contact" className="contact-link">
            <ContactSVG className="contact-svg" />
          </a>
        </div>
      </div>

      <div className="hero-image-container container-padding">
        <img
          src="/images/OMO_Logo_Inflate_3D_Big.png"
          alt="OMO Creative Hero"
          className="hero-main-image"
        />
      </div>
    </section>
  );
}

export default HeroSection;
